import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Routes } from '@angular/router';
import { BreadcrumbItem } from '@infocert/ng-ui-kit/models';
import { TranslateService } from '@ngx-translate/core';
import {
    combineLatest,
    distinctUntilChanged,
    filter,
    map,
    Observable
} from 'rxjs';
import { BreadcrumbDefinition, BreadcrumbService } from 'xng-breadcrumb';
export interface IBreadCrumb {
  label: string;
  url: string;
}
@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbItems$: Observable<BreadcrumbItem[]>;

  public breadcrumbs: IBreadCrumb[];

  constructor(
    private _router: Router,
    private _breadcrumbService: BreadcrumbService,
    private _translateService: TranslateService,
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
  }

  isHomepage = false;

  ngOnInit(): void {
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
      });

    this.breadcrumbItems$ = combineLatest([
      this._breadcrumbService.breadcrumbs$,
      this._translateService.stream(this._getBreadcrumbs(this._router.config)),
    ])
      .pipe(
        map((res: [BreadcrumbDefinition[], { [key: string]: string }]) => {
          return this._mapBreadcrumbItems(res[0], res[1]);
        })
      )
      .pipe(mapped => {
        console.log('breadcrumbItems', mapped);
        return mapped;
      });
  }

  private _getBreadcrumbs(config: Routes): string[] {
    const keys = new Set<string>(['HEADER.HOMEPAGE']);

    const collect = (routes: Routes) => {
      (routes || []).forEach(route => {
        const breadcrumbKey = route?.data?.['breadcrumb'];
        if (breadcrumbKey) {
          keys.add(breadcrumbKey);
        }
        if (route?.children?.length) {
          collect(route.children);
        }
      });
    };

    collect(config);
    return Array.from(keys);
  }

  private _mapBreadcrumbItems(
    items: BreadcrumbDefinition[],
    translations: { [key: string]: string }
  ): BreadcrumbItem[] {

    if(window.location.hash === '#/'){
        window.location.href = '/#/oauth2';
    }
    
    console.log('isHomepage', this.isHomepage);

    const homeBreadCrumb: BreadcrumbDefinition = {
      label: 'HEADER.HOMEPAGE',
      routeLink: 'homepage',
    };

    const itemsWithHome = [homeBreadCrumb, ...items];
    return (itemsWithHome || []).map(
      item =>
        ({
          label: translations[item.label as string],
          routerLink: item.routeLink,
        } as BreadcrumbItem)
    );
  }

  /**
   * Recursively build breadcrumb according to activated route.
   * @param route
   * @param url
   * @param breadcrumbs
   */
  buildBreadCrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: IBreadCrumb[] = []
  ): IBreadCrumb[] {
    //If no routeConfig is avalailable we are on the root path
    let label =
      route.routeConfig && route.routeConfig.data
        ? route.routeConfig.data['breadcrumb']
        : '';
    let isClickable =
      route.routeConfig &&
      route.routeConfig.data &&
      route.routeConfig.data['isClickable'];
    let path =
      route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';

    // If the route is dynamic route such as ':id', remove it
    const lastRoutePart = path.split('/').pop();
    const isDynamicRoute = lastRoutePart.startsWith(':');
    if (isDynamicRoute && !!route.snapshot) {
      const paramName = lastRoutePart.split(':')[1];
      path = path.replace(lastRoutePart, route.snapshot.params[paramName]);
      label = route.snapshot.params[paramName];
    }

    //In the routeConfig the complete path is not available,
    //so we rebuild it each time
    const nextUrl = path ? `${url}/${path}` : url;

    const breadcrumb: IBreadCrumb = {
      label: label,
      url: nextUrl,
    };
    // Only adding route with non-empty label
    const newBreadcrumbs = breadcrumb.label
      ? [...breadcrumbs, breadcrumb]
      : [...breadcrumbs];
    if (route.firstChild) {
      //If we are not on our current path yet,
      //there will be more children to look after, to build our breadcumb
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }

  goToHomepage() {
    this._router.navigate(['/homepage']);
  }
}
